import React from 'react';

interface ProductDiscontinuedProps {
  discontinuedValue: string | null;
}

const ProductDiscontinued: React.FC<ProductDiscontinuedProps> = ({
  discontinuedValue = 'temporiamente',
}) => {
  if (!discontinuedValue) {
    return null;
  }

  const getDiscontinuedText = (value: string) => {
    return `ATENÇÃO: A QUALIDOC INFORMA QUE ESTE MEDICAMENTO FOI DESCONTINUADO ${value} PELO FABRICANTE. (FONTE: ANVISA).`;
  };

  return (
    <div className="my-8 p-1 border-2 border-red-200 rounded-lg box-border">
      <p className="text-white bg-red-200 text-sm font-semibold rounded-md p-2 text-left uppercase leading-relaxed">
        {getDiscontinuedText(discontinuedValue)}
      </p>
    </div>
  );
};

export default ProductDiscontinued;
